import React from 'react'
import { Box, Button, Image, Media, Text } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'

const Benefit = ({
  canAccess,
  title,
  description,
  benefitUrl,
  enabledButtonText,
  disabledButtonText,
  imageProps,
}) => (
  <Media>
    {
      imageProps && imageProps.src
        ? (
          <Media.Figure size="medium" horizontalAlignment="right">
            <Image {...imageProps} />
          </Media.Figure>
        )
        : null
    }
    <Media.Content>
      <Text isBold hasEllipsis>
        {title}
      </Text>
      <Text display="block">
        {description}
      </Text>
      <Button
        type="button"
        disabled={!canAccess}
        color="primary"
        onClick={() => window && window.Turbolinks && window.Turbolinks.visit(benefitUrl)}
      >
        { canAccess ? enabledButtonText : disabledButtonText }
      </Button>
    </Media.Content>
  </Media>
)

export default Benefit
